/* eslint-disable no-param-reassign */
import Vue from 'vue';
import user from '../user';

const UserPlugin = {
    install(/* vue */) {
        Vue.mixin({
            methods: {
                $hasPermission(permission) {
                    if (permission === null) return true;
                    return this.$user.permissions.filter(p => p.enabled).map(p => p.role).includes(permission);
                },
                $hasAdminPermission() {
                    return this.$hasPermission(this.$ADMIN_PERMISSION)
                },
                $hasEditPermission(vastuualueId) {
                    return this.$hasAdminPermission() || !vastuualueId || (vastuualueId && vastuualueId > 0 && this.$user.vastuualueLinkit?.find(v => v.vastuualueId === vastuualueId)?.rooli === 'role_member')
                },
                $hasGuestPermission(vastuualueId) {
                    return this.$hasAdminPermission() || !vastuualueId || (vastuualueId && vastuualueId > 0 && this.$user.vastuualueLinkit?.find(v => v.vastuualueId === vastuualueId)?.rooli === 'role_guest')
                },
                $setUser(u) {
                    user.user = u;
                },
            },
            computed: {
                $ADMIN_PERMISSION() {
                    return 'strategia_admin'
                },
                $user() {
                    return user.user;
                },
            },
        });
    },
};

export default UserPlugin;
